export interface TaxOptions {
  [key: string]: TaxOption;
}

export enum TaxType {
  IVA = 'IVA',
  IGIC = 'IGIC',
  IPSI = 'IPSI',
}

export enum NonTaxableTaxType {
  Exempt = 'Exempt',
  NotSubject = 'NotSubject',
  ReverseCharge = 'ReverseCharge',
}

export type TaxKey =
  | `${TaxType}_${NonTaxableTaxType}_0`
  | `${TaxType}_${number}`
  | `${TaxType}_${number}_${number}`;

export interface TaxOption {
  label: string;
  amount: number;
  type: TaxType;
  value: TaxKey;
  hide?: boolean;
  salesEqTaxPercentage?: number;
  onlyExpenses?: boolean;
}

export interface TaxLine {
  base: number;
  tax: TaxOption;
  saleEqualization?: number;
  saleEqualizationAmount: number;
  taxAmount: number;
}
